import React from 'react';
import { Input } from 'reactstrap';
import withFormsyValidations from 'flaivy-react/components/withFormsyValidations';

//Gemini wrote this for us
function isCronValid(cronString: string): boolean {
  if (typeof cronString !== 'string') {
    return false;
  }

  const parts = cronString.trim().split(/\s+/);
  if (parts.length !== 5 && parts.length !== 6) {
    return false;
  }

  const [minute, hour, dayOfMonth, month, dayOfWeek, second] = parts;
  const hasSeconds = parts.length === 6;

  const ranges: [number, number][] = [
    [0, 59], // Minutes
    [0, 23], // Hours
    [1, 31], // Day of month
    [1, 12], // Month
    [0, 6], // Day of week (0 or 7 is Sunday)
  ];

  if (hasSeconds) {
    ranges.unshift([0, 59]); // Seconds
  }

  const aliases: { [key: string]: string } = {
    jan: '1',
    feb: '2',
    mar: '3',
    apr: '4',
    may: '5',
    jun: '6',
    jul: '7',
    aug: '8',
    sep: '9',
    oct: '10',
    nov: '11',
    dec: '12',
    sun: '0',
    mon: '1',
    tue: '2',
    wed: '3',
    thu: '4',
    fri: '5',
    sat: '6',
  };

  function isValidPart(part: string, range: [number, number]): boolean {
    if (part === '*') {
      return true;
    }

    const segments = part.split(',');
    for (const segment of segments) {
      if (segment.includes('/')) {
        const [base, step] = segment.split('/');
        if (
          base &&
          base !== '*' &&
          (!/^\d+$/.test(base) ||
            parseInt(base, 10) < range[0] ||
            parseInt(base, 10) > range[1])
        ) {
          return false;
        }
        if (step && (!/^\d+$/.test(step) || parseInt(step, 10) < 1)) {
          return false;
        }
      } else if (segment.includes('-')) {
        const [start, end] = segment.split('-');
        if (
          start &&
          end &&
          (!/^\d+$/.test(start) ||
            !/^\d+$/.test(end) ||
            parseInt(start, 10) < range[0] ||
            parseInt(end, 10) > range[1] ||
            parseInt(start, 10) > parseInt(end, 10))
        ) {
          return false;
        }
      } else if (
        !/^\d+$/.test(segment) ||
        parseInt(segment, 10) < range[0] ||
        parseInt(segment, 10) > range[1]
      ) {
        return false;
      }
    }
    return true;
  }

  const partsToCheck = hasSeconds
    ? [second, minute, hour, dayOfMonth, month, dayOfWeek]
    : [minute, hour, dayOfMonth, month, dayOfWeek];

  for (let i = 0; i < partsToCheck.length; i++) {
    const part = (partsToCheck[i] ?? '').toLowerCase();
    const range = ranges[i];

    let replacedPart = part;
    for (const alias in aliases) {
      const regex = new RegExp(`\\b${alias}\\b`, 'gi');
      replacedPart = replacedPart.replace(regex, aliases[alias] ?? '');
    }

    if (range && !isValidPart(replacedPart, range)) {
      return false;
    }
  }

  // Basic check for day of month and day of week mutual exclusivity (not comprehensive)
  if (dayOfMonth !== '*' && dayOfWeek !== '*') {
    // This doesn't catch all invalid combinations, but it's a common error.
    // More sophisticated validation would require a deeper understanding of cron logic.
  }

  return true;
}
interface CronScheduleInputProps {
  name: string;
  className?: string;
  setValue: (value: string, validate: boolean) => void;
  required?: boolean;
  disabled?: boolean;
  onChange: (name: string, value: string) => void;
  value?: string | null;
  id?: string;
  errorMessage?: string;
  isValid?: boolean;
}

const CronScheduleInput: React.FC<CronScheduleInputProps> = ({
  name,
  className = '',
  required = false,
  disabled = false,
  onChange,
  value = '',
  id,
  errorMessage,
  isValid,
}) => {
  return (
    <div>
      <Input
        invalid={!isValid}
        type="text"
        id={id}
        className={className}
        required={required}
        disabled={disabled}
        value={value || ''}
        name={name}
        onChange={event => onChange(name, event.target.value)}
        placeholder="* * * * *"
      />
      <span>{errorMessage}</span>
    </div>
  );
};

export default withFormsyValidations(
  CronScheduleInput,
  (props: CronScheduleInputProps) => ({
    validCron(values: any, value: string) {
      return isCronValid(value);
    },
    requiredValidation(values: any, value: string) {
      if (props.required) {
        return !!value && value.trim() !== '';
      }
      return true;
    },
  }),
);
